<script>

export let totalLinhas=3;
</script>

<style>
.observacoes-container {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 20px; /* Espaçamento abaixo do componente */
  background-color: white;
  border-radius: 5px;
}

.observacoes-titulo {
  font-weight: bold;
  margin-bottom: 5px;
}

.linha {
  width: 100%;
  height: 25px; /* Altura da linha para escrita */
  border-bottom: 1px solid #ccc;
  margin-bottom: 5px;
}
</style>

<div class="observacoes-container">
  <div class="observacoes-titulo">Observações:</div>
  {#each Array(totalLinhas) as _, index}
    <div class="linha" />
  {/each}
  
 </div>